module.exports = require('./helpers/bundle-url').getBundleURL('dsYo6') + "logo-dark.eefe0b7f.svg";